.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.instructions {
    grid-column: var(--grid-column);
    margin-bottom: 1em;
}

.title {
    composes: fontHeader34 from "../../styles/composable/typography.module.css";
    text-align: center;
    margin-block: 1em;
}

.text {
    li {
        margin-top: 0;
        margin-bottom: 0;
    }
}
